import { render, staticRenderFns } from "./ProjectCommentLogin.vue?vue&type=template&id=5943fd4d"
import script from "./ProjectCommentLogin.vue?vue&type=script&lang=js"
export * from "./ProjectCommentLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports